export default __webpack_public_path__ + "media/images/icons_fc/user2-fadca7d3bd3a0b3ef32d0b93fe70bd48.png";